import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class Animations {
  static init() {
    console.log('== Animations components ==')

    const main = document.querySelector('.main-wrapper')

    // Show main container
    const tlInit = gsap.timeline()

    tlInit.from(main, {autoAlpha: 0})

    // Hero main load animation

    if (main.classList.contains('front-page')) {
      console.log('  -> Animate main viewport')

      const header = document.querySelector('.header')
      const sectionHero = document.querySelector('.section--hero')

      const tlMainViewport = gsap.timeline()

      tlMainViewport
        .from(header, {
          autoAlpha: 0,
          delay: 0.25,
          duration: 1,
          ease: 'expo.out',
        })
        .from(sectionHero, {
          delay: -0.75,
          duration: 1,
          opacity: 0,
          ease: 'expo.out',
        })

      console.log('  -> Animate hero')

      const gridElements = Array.from(
        sectionHero.querySelectorAll('.grid-elem')
      )

      gridElements.forEach((elem) => {
        const tlGridElem = gsap.timeline()

        tlGridElem.from(elem, {
          delay: getRandomNumber(0.5, 1.75),
          duration: getRandomNumber(1.75, 2.75),
          repeat: -1,
          scale: 0,
          yoyo: true,
        })
      })
    }

    // Symbols animations

    console.log('  -> Animate symbols')

    const sectionSymbols = document.querySelector('.section--symbols')
    const symbolElements = Array.from(
      sectionSymbols.querySelectorAll('.symbol')
    )

    symbolElements.forEach((symbol) => {
      let tlSymbol = gsap.timeline()

      tlSymbol.from(symbol, {
        rotation: getRandomSign() * getRandomNumber(90, 360),
        scrollTrigger: {
          trigger: sectionSymbols,
          scrub: 1,
        },
      })
    })

    // Logo horizontal animations

    console.log('  -> Logo horizontal symbols')

    const footerBottom = document.querySelector('.footer-bottom')
    const horizontalLogoLetters = document.querySelectorAll(
      '#logo-horizontal path, #logo-footer path'
    )

    let tlHorizontalLogoLetters = gsap.timeline()

    tlHorizontalLogoLetters.from(horizontalLogoLetters, {
      duration: 0.75,
      scaleY: 0,
      ease: 'bounce',
    })

    ScrollTrigger.create({
      trigger: footerBottom,
      start: 'top 90%',
      end: 'bottom 95%',
      animation: tlHorizontalLogoLetters,
      markers: false,
      toggleActions: 'play none none none',
    })

    // General animations

    console.log('  -> Animate general components')

    const animateFadeEarly = document.querySelectorAll('.animate-fade-early')

    animateFadeEarly.forEach((item) => {
      let tlItem = gsap.timeline({paused: true})

      tlItem.from(item, {
        autoAlpha: 0,
        duration: 1,
        ease: 'expo.out',
      })

      ScrollTrigger.create({
        trigger: item,
        start: 'top 90%',
        end: 'bottom 95%',
        animation: tlItem,
        markers: false,
        toggleActions: 'play none none reverse',
      })
    })

    const animateRight = document.querySelectorAll('.animate-right')
    const animateLeft = document.querySelectorAll('.animate-left')

    animateHorizontal(animateRight, 50)
    animateHorizontal(animateLeft, -50)

    const animateZoomOut = document.querySelectorAll('.animate-zoomout')

    animateZoomOut.forEach((item) => {
      let tlItem = gsap.timeline({paused: true})

      tlItem.from(item, {
        autoAlpha: 0,
        duration: 1,
        ease: 'expo.out',
        scale: 1.25,
      })

      ScrollTrigger.create({
        trigger: item,
        start: 'top 85%',
        end: 'bottom 95%',
        animation: tlItem,
        markers: false,
        toggleActions: 'play none none reverse',
      })
    })

    const animateTwist = document.querySelectorAll('.animate-twist')

    animateTwist.forEach((item) => {
      let tlItem = gsap.timeline({paused: true})

      tlItem.from(item, {
        autoAlpha: 0,
        duration: 1.75,
        ease: 'expo.out',
        rotation: -120,
        scale: 0.5,
        transformOrigin: '50% 50%',
      })

      ScrollTrigger.create({
        trigger: item,
        start: 'top 85%',
        end: 'bottom 95%',
        animation: tlItem,
        markers: false,
        toggleActions: 'play none none reverse',
      })
    })
  }

  static destroyScrolls() {
    ScrollTrigger.killAll()
  }
}

function getRandomNumber(min, max) {
  return Math.random() * (max - min) + min
}

function getRandomSign() {
  return Math.random() < 0.5 ? -1 : 1
}

function animateHorizontal(items, offset) {
  items.forEach((item) => {
    let tlItem = gsap.timeline({paused: true})

    tlItem.from(item, {
      autoAlpha: 0,
      duration: 1,
      x: offset,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: 'top 85%',
      end: 'bottom 90%',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none reverse',
    })
  })
}
